export var version = '3.7.6';
//# sourceMappingURL=version.js.map